/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Transcript_Export_Field_OriginalInputs */



/**
* | output |
* | --- |
* | "Original" |
*
* @param {Transcript_Export_Field_OriginalInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const transcript_export_field_original = /** @type {((inputs?: Transcript_Export_Field_OriginalInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transcript_Export_Field_OriginalInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Original")
	if (locale === "de") return /** @type {LocalizedString} */ ("Original")
	if (locale === "it") return /** @type {LocalizedString} */ ("Original")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Original")
	if (locale === "es") return /** @type {LocalizedString} */ ("Original")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Original")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Original")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Original")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Original")
	return /** @type {LocalizedString} */ ("Original")
});